export default "__VITE_ASSET__E$ejTjFA__"